/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserInviteRequest {
    getFixupPrototypeFunction() { return UserInviteRequest.fixupPrototype; }

    static newInstance(model: Partial<UserInviteRequest>): UserInviteRequest {
        let obj = Object.assign(new UserInviteRequest(), model);
        UserInviteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserInviteRequest>): UserInviteRequest {
        if (!model) return null;
        return UserInviteRequest.newInstance(<UserInviteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserInviteRequest) {
        if (!obj) return;

        models.UserInviteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserInviteRequest): boolean {
        Object.setPrototypeOf(obj, UserInviteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tenants) {
            for (let val of this.tenants) {
                models.UserInviteTenantRoles.fixupPrototype(val);
            }
        }
    }

    /**
     * Email ID of the user. This wil be unique across all the CoreStack accounts
     */
    email: string;

    /**
     * List of roles assignments for the user. The same user can be assigned different roles in different tenants
     */
    tenants: Array<models.UserInviteTenantRoles>;

    /**
     * ID of the Account Master in CoreStack
     */
    master_account_id: string;

    user_groups: Array<string>;

}
